<template>
  <UIDropdown :container :placement :disabled>
    <template #default="{ toggle }">
      <slot v-bind="{ toggle }" />
    </template>
    <template #popper="{ hide }">
      <div class="ui-dropdown-confirm">
        <slot name="message">{{ message }}</slot>
        <div class="ui-dropdown-confirm__buttons">
          <UIButton
            label="Yes"
            variant="danger"
            size="xs"
            :leading="CheckIcon"
            @click="handleConfirm(hide)"
          />
          <UIButton
            label="No"
            variant="secondary"
            size="xs"
            :leading="XMarkIcon"
            @click="hide"
          />
        </div>
        <slot name="after" />
      </div>
    </template>
  </UIDropdown>
</template>

<script setup lang="ts">
import { Placement } from 'floating-vue'

import UIDropdown from './Dropdown.vue'
import UIButton from '../Button/Button.vue'
import { CheckIcon } from '@heroicons/vue/24/outline'
import { XMarkIcon } from '@heroicons/vue/24/outline'

type Props = {
  message?: string

  disabled?: boolean

  container?: string
  placement?: Placement
}

type Emits = {
  'confirm': [callback: () => void]
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleConfirm = (hide: () => void) => {
  emit('confirm', hide)
}
</script>

<style>
.ui-dropdown-confirm {
  @apply w-64;
  @apply p-2.5;
  @apply text-sm sm:text-xs;
  @apply text-light-text;
  @apply text-center;

  &__buttons {
    @apply flex justify-center;
    @apply gap-2;
    @apply pt-2;
  }
}
</style>
